// Auth
export const urlRefreshToken = 'auth/refresh-token';
export const urlApiAuth = {
  login: 'auth/login',
  refreshToken: 'auth/refresh-token',
};

// Profile
export const urlApiUser = {
  base: 'users',
  getList: 'users/profile',
  updateProfile: 'users/profile',
  getStudents: 'users/students',
};

// Notifications
export const urlNotifications = {
  getList: 'notifications',
};

// Course
export const urlApiCourse = {
  base: 'courses',
  getCourseUpcoming: 'courses/upcoming',
  getDetail: (coursesId: string, moduleId: string) => `courses/${coursesId}/modules/${moduleId}`,
  getCoursesOfStudent: 'courses/of-student',
  getModulesOfCourse: (coursesId: string) => `courses/${coursesId}/modules`,
  getDiscussionsOfCourse: (coursesId: string) => `courses/${coursesId}/discussions`,
};

// Canvas
export const urlApiCanvas = {
  signIn: 'canvas/auth-url',
  createCanvasToken: 'canvas/token',
};

// Tuition
export const urlTuition = {
  getList: 'tuitions',
  create: 'tuitions/new',
  update: (tuitionId: string) => `tuitions/${tuitionId}`,
  deleteById: (tuitionId: string) => `tuitions/${tuitionId}`,
  getById: (tuitionId: string) => `tuitions/${tuitionId}`,
};

// Exam
export const urlExam = {
  getList: 'exams',
  create: 'exams/new',
  update: (examId: string) => `exams/${examId}`,
  deleteById: (examId: string) => `exams/${examId}`,
  getById: (examId: string) => `exams/${examId}`,
};

// Discussion Forum Grading
export const urlDiscussionForumGrading = {
  getList: 'discussion-forum-grades',
  create: 'discussion-forum-grades/new',
  update: (id: string) => `discussion-forum-grades/${id}`,
  deleteById: (id: string) => `discussion-forum-grades/${id}`,
};

// Discussion
export const urlApiDiscussion = {
  detail: 'discussions/detail',
  getEntries: 'discussions/entries',
  getFullEntries: 'discussions/full-entries',
  createEntry: 'discussions/entries',
  createReply: 'discussions/entry-replies',
  markReadAllEntries: 'discussions/read-all',
};

// Quiz
export const urlApiQuiz = {
  detail: 'quizzes/detail',
  startQuiz: 'quizzes/start',
  answerQuestion: 'quizzes/questions',
  answerFileQuestion: 'quizzes/file-questions',
  completeQuiz: 'quizzes/complete',
};

// Module
export const urlApiModule = {
  base: 'modules',
};
